import type { RawCategoryApiResponse } from './Category';

export enum ProductStatus {
  ACTIVE = 'ACTIVE',
  ARCHIVED = 'ARCHIVED',
}

export interface RawProductApiResponse {
  base_price_cents?: number | null;
  brand?: string | null;
  catalog_key: string;
  categories: RawCategoryApiResponse[];
  created_at: string;
  custom?: any;
  gtins: Array<string>;
  id: string;
  image_url?: string | null;
  import_file?: string | null;
  max_price_cents?: number | null;
  min_price_cents?: number | null;
  name?: string | null;
  sku: string;
  status: ProductStatus;
  updated_at: string;
}

export interface Category {
  category_key: string;
  category_name: string;
}

export interface RawProductApiCreateRequest {
  gtins: Array<string>;
  image_url: string | null;
  name: string;
  description: string | null;
  brand: string | null;
  base_price_cents: number | null;
  categories: Array<Category>;
  status: ProductStatus;
  custom: any;
}
